module.exports = __webpack_public_path__ + "img/express-area.207f5b7c.jpg";